import { ProviderType } from "../../services/cloudchipr.api";

export const liveResourcesCloudProviders: ProviderType[] = [
  "aws",
  "gcp",
  "azure",
  "kubernetes",
];
